/* eslint-disable react/prop-types */
import React from 'react';

const MegaMenuMobileButtonLink = ({
  href,
  title,
  target,
  iconSrc,
  onTitleClick
}) => {
  if (href) {
    return (
      <a
        className="mega-menu-mobile__link-block-header"
        href={href}
        target={target}
      >
        {title}
        {iconSrc && <img src={iconSrc} width={15} height={15} />}
      </a>
    );
  }

  const icon = iconSrc ? (
    <img src={iconSrc} width={15} height={15} />
  ) : (
    <svg role="presentation" width={15} height={15} fill="#ffffff">
      <use xlinkHref="#chevron-right" />
    </svg>
  );

  return (
    <button
      className="mega-menu-mobile__link-block-header"
      onClick={() => onTitleClick()}
    >
      {title}
      {icon}
    </button>
  );
};

export default MegaMenuMobileButtonLink;
